import React from 'react'
import { LayoutGroup } from './layout/LayoutGroup'

export const GroupScreen = () => {
    return (
        <LayoutGroup />
    )
}
